var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPermablokPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 776.34 134.54",
    style: {
      enableBackground: "new 0 0 776.34 134.54"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#066695;}\n\t.st1{fill:#010101;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#010101;}\n\t.st3{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M523.62,63.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M538.75,59.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M514.51,49.56v37.36v11.71v18.79h217.66c18.74,0,33.94-15.2,33.94-33.94c0-18.75-15.2-33.94-33.94-33.94 H549.16"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.41,110.17l-2.83,6.23h-3.33l11.86-25.9l11.87,25.9h-3.33l-2.83-6.23H17.41z M23.11,97.29l-4.42,10.05 h8.83L23.11,97.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.61,91.56h5.14c7.61,0,13.94,4.02,13.94,12.29c0,8.47-6.19,12.55-14.04,12.55h-5.04V91.56z M40.71,113.56 h1.08c6.33,0,11.8-2.38,11.8-9.59c0-7.25-5.47-9.59-11.8-9.59h-1.08V113.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M68.81,109.94l7.38-18.38h3.39l-10.78,26.16L58.01,91.56h3.39L68.81,109.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.05,110.17l-2.83,6.23h-3.33l11.86-25.9l11.86,25.9h-3.33l-2.83-6.23H86.05z M91.75,97.29l-4.41,10.05 h8.83L91.75,97.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.22,90.37l18.65,19.54V91.56h3.1v25.86l-18.65-19.54v18.52h-3.1V90.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.3,96.3c-1.78-1.58-4.22-2.43-6.56-2.43c-5.57,0-9.82,4.64-9.82,10.15c0,5.44,4.22,10.08,9.75,10.08 c2.44,0,4.78-0.92,6.63-2.57v3.65c-1.91,1.12-4.35,1.75-6.52,1.75c-7.09,0-12.95-5.64-12.95-12.82c0-7.35,5.9-13.08,13.22-13.08 c2.17,0,4.38,0.53,6.26,1.68V96.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155.81,91.56h13.35v2.83h-10.25v6.96h9.95v2.83h-9.95v9.39h10.25v2.83h-13.35V91.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M173.54,91.56h5.14c7.61,0,13.94,4.02,13.94,12.29c0,8.47-6.2,12.55-14.04,12.55h-5.04V91.56z M176.64,113.56 h1.09c6.32,0,11.8-2.38,11.8-9.59c0-7.25-5.47-9.59-11.8-9.59h-1.09V113.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M215.1,109.94l7.38-18.38h3.39l-10.78,26.16l-10.81-26.16h3.4L215.1,109.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M231.81,116.4h-3.1V91.56h3.1V116.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M236.98,90.37l18.65,19.54V91.56h3.1v25.86l-18.65-19.54v18.52h-3.1V90.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M261.39,91.56h3.56l6.1,10.6l6.1-10.6h3.56l-8.1,14.03v10.81h-3.1v-10.81L261.39,91.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M286.77,113.56h7.54v2.83h-10.64V91.56h3.1V113.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M310.63,116.4h-3.1V91.56h3.56c7.65,0,10.02,2.63,10.02,7.18c0,5.24-3.99,7.25-8.7,7.25h-1.78V116.4z  M310.63,103.22h0.99c3.16,0,6.59-0.59,6.59-4.55c0-3.89-3.69-4.35-6.76-4.35h-0.82V103.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M340.12,116.4h-3.76l-7.31-10.51h-1.28v10.51h-3.1V91.56h3.76c2.21,0,4.58,0.03,6.56,1.15 c2.08,1.22,3.26,3.56,3.26,5.93c0,3.56-2.38,6.52-5.96,6.95L340.12,116.4z M327.76,103.32h0.99c3.16,0,6.59-0.59,6.59-4.55 c0-3.88-3.69-4.45-6.76-4.45h-0.82V103.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M367.67,103.98c0,7.38-5.83,12.95-13.02,12.95c-7.19,0-13.02-5.57-13.02-12.95c0-7.12,5.9-12.95,13.02-12.95 C361.77,91.03,367.67,96.86,367.67,103.98z M364.57,103.98c0-5.47-4.09-10.05-9.92-10.05c-5.83,0-9.92,4.58-9.92,10.05 c0,5.67,4.55,10.05,9.92,10.05C360.02,114.02,364.57,109.65,364.57,103.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M378.18,116.4h-3.1V94.38h-5.9v-2.83h14.9v2.83h-5.9V116.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M387.34,91.56h13.34v2.83h-10.25v6.96h9.95v2.83h-9.95v9.39h10.25v2.83h-13.34V91.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M423.43,96.3c-1.78-1.58-4.22-2.43-6.56-2.43c-5.57,0-9.82,4.64-9.82,10.15c0,5.44,4.22,10.08,9.75,10.08 c2.44,0,4.78-0.92,6.62-2.57v3.65c-1.91,1.12-4.35,1.75-6.53,1.75c-7.08,0-12.95-5.64-12.95-12.82c0-7.35,5.9-13.08,13.21-13.08 c2.18,0,4.38,0.53,6.26,1.68V96.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M434.63,116.4h-3.1V94.38h-5.9v-2.83h14.89v2.83h-5.9V116.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M446.79,116.4h-3.1V91.56h3.1V116.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M476.55,103.98c0,7.38-5.83,12.95-13.02,12.95c-7.18,0-13.01-5.57-13.01-12.95c0-7.12,5.9-12.95,13.01-12.95 C470.65,91.03,476.55,96.86,476.55,103.98z M473.45,103.98c0-5.47-4.09-10.05-9.92-10.05c-5.83,0-9.92,4.58-9.92,10.05 c0,5.67,4.55,10.05,9.92,10.05C468.9,114.02,473.45,109.65,473.45,103.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M480.07,90.37l18.65,19.54V91.56h3.1v25.86l-18.65-19.54v18.52h-3.1V90.37z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M55.25,16.05l-31.81,0.08l-12.19,58.1l6.91,0.01l4.8-22.13l19.96,0.03c19.07,1.07,20.77-17.94,20.77-17.94 C66.77,16.05,55.25,16.05,55.25,16.05z M57.19,35.21c-2.66,12.83-13.57,11.41-13.57,11.41l-19.57-0.09l5.16-24.65 c2,0,22.6,0.06,22.6,0.06c5.34,0,5.72,3.77,5.72,3.77C58.27,31.38,57.19,35.21,57.19,35.21z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "72.78,16.14 60.41,74.24 97.5,74.27 98.91,68.39 68.31,68.39 73.13,47.42 102,47.37 103.44,41.48  74.16,41.58 78.29,21.98 108.88,21.98 110.26,16.14  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M159.73,22.64c0,0-2.26-6.42-12.64-6.58l-28.92,0.08l-12.38,58.1h6.88l5.02-22.91c0,0,10.63-0.04,21.62-0.04 c0,0,8.99-0.34,6.88,8.94l-2.58,14.01h6.53l3.36-16.86c0,0,1.75-7.6-6.41-9.01c0,0,8.97-1.43,11.55-9.41 C158.63,38.96,161.8,30.96,159.73,22.64z M152.86,37.49c-1.67,6.77-12.39,7.72-12.39,7.72l-21.57,0.08l4.74-23.66h17.33 c13.07-0.17,13.1,4.86,13.1,4.86C155.22,31.49,152.86,37.49,152.86,37.49z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "159.76,74.24 166.29,74.24 177.98,21.29 188.64,74.24 195.17,74.24 228.14,21.57 217.18,74.24  223.71,74.24 236.08,16.14 224.74,16.14 193.45,65.64 183.48,16.14 172.14,16.14  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M271.84,16.14h-9.28l-33,58.1h6.88l7.22-12.37h28.88l2.06,12.37l6.82,0.07L271.84,16.14z M246.84,56.31 l19.49-33.98l5.27,33.98H246.84z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M336.86,16.89c0,0-0.03-1.19-38.87-0.83L286,74.25h34.98c0,0,13.34,0.06,16.19-9.74 c0,0,4.68-10.88,1.36-16.4c0,0-0.48-2.63-6.53-3.09c0,0,9.98-2.25,11.05-10.62C343.05,34.4,347.36,18.39,336.86,16.89z  M323.14,56.49c-1.03,5.28-6.77,5.2-6.77,5.2l-12.33,0.08l1.99-10.45l13.58-0.04c0,0,1.91,0.08,2.83,1.25 C323.51,53.88,323.14,56.49,323.14,56.49z M327.31,33.84c-1.03,5.28-6.77,5.2-6.77,5.2l-12.32,0.08l1.99-10.45l13.58-0.04 c0,0,1.92,0.08,2.83,1.25C327.67,31.22,327.31,33.84,327.31,33.84z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "354.69,16.14 370.5,16.14 360.87,60.94 385,60.86 382.19,74.24 342.31,74.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "458.52,16.14 446.48,74.24 461.95,74.24 466.76,51.55 471.58,51.55 482.92,74.24 501.83,74.24  486.11,45.09 512.3,16.05 494.27,16.14 473.89,38.15 469.67,38.27 474.33,16.14  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M448.13,26.72c0,0-2.11-10.13-16.36-10.85c0,0-12.47-1.43-22.27,1.42c0,0-9.98,2.31-14.61,14.07 c0,0-5.7,21.73-5.88,27.44c0,0-2.5,11.4,10.15,14.78c0,0,18.1,3.53,29.86-0.57c0,0,11.97-3.68,14.32-16.43 C443.36,56.59,449.24,30.6,448.13,26.72z M427.5,53.99c-2.32,6.95-7.13,6.77-7.13,6.77c-4.28,0.89-10.33,0-10.33,0 c-4.63-0.71-4.28-5.35-4.28-5.35c0.53-7.66,4.63-20.31,4.63-20.31c1.6-4.1,5.49-5.22,5.49-5.22c4.42-0.95,10.37-0.3,10.37-0.3 c5.44,0.24,4.99,6.59,4.99,6.59C431.42,39.74,427.5,53.99,427.5,53.99z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M543.05,106.39l9.72-45.81h23.03c11.36,0,14.66,4.83,12.1,16.8c-2.75,12.89-6.54,17.29-19.31,17.29h-10.81 l-2.51,11.73H543.05z M568.4,84.03c4.82-0.18,5.63-0.74,6.9-6.66c0.98-4.71,0.55-6.17-4.21-6.17h-8.37l-2.69,12.83H568.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M600.96,95.76h19.13l-2.26,10.63h-31.34l9.72-45.81h12.21L600.96,95.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M671.72,60.57l-6.48,30.54c-2.57,12.22-9.04,15.64-22.48,15.64c-18.33,0-19.31-4.64-16.98-15.64l6.47-30.54 h12.22l-6.42,30.3c-1.1,5.2,1.83,5.25,6.96,5.25c5.2,0,7.03-0.42,8.19-5.8l6.29-29.75H671.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M696.34,78.53c13.38,0.97,16.37,2.68,14.11,13.2c-1.59,7.57-2.87,15.02-23.03,15.02 c-11.67,0-19.37-0.24-16.19-15.27h11.73c-1.04,4.76,0.61,5.25,6.6,5.25c5.74,0,7.7-0.37,8.49-4.21c0.85-3.98,0.18-3.92-5.5-4.28 l-2.62-0.18c-11.12-0.79-17.78-0.74-14.97-13.87c2.81-13.13,10.38-13.99,22.36-13.99c10.02,0,18.52,0.18,15.82,12.82l-0.42,1.9 h-11.73c1.04-4.7-0.92-4.7-5.81-4.7c-6.6,0-7.45,1.34-8,3.91c-0.8,3.67,0.98,3.79,4.15,4.04L696.34,78.53z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M732.85,68.06h7.02l-2.5,11.67h11.79l-1.47,7.02H735.9l-2.63,12.15h-7.03l2.63-12.15h-11.73l1.46-7.02h11.74 L732.85,68.06z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermablokPlus);
export default __webpack_public_path__ + "static/media/permablok-plus.9a611d69bc70161f8fd1c4765c556018.svg";
export { ForwardRef as ReactComponent };